import { Card, CardStatus } from '../types'

type GetCardStatusType = (params: {
  statusDetails: Card['statusDetails']
  isCardEmbossed: boolean
}) => CardStatus

export const getCardStatus: GetCardStatusType = ({
  statusDetails,
  isCardEmbossed,
}) => {
  const INACTIVE_STATUS_CODE = '00'
  const ACTIVE_STATUS_CODE = '01'
  const ONHOLD_STATUS_CODES = ['02', '03', '05']
  const { status } = statusDetails
  if (status === INACTIVE_STATUS_CODE && isCardEmbossed) {
    return 'inactive'
  }

  if (status === ACTIVE_STATUS_CODE) {
    return 'active'
  }

  if (ONHOLD_STATUS_CODES.includes(status)) {
    return 'onHold'
  }

  return 'hidden'
}
